import User, {UserDTO} from "@/model/user";
import { AxiosResponse } from "axios";
import api, { ApiResponse } from "./api";
import PaginateModel, {PaginateDTO} from "@/model/paginate";
import UserCompany from "@/model/userCompany";

interface AuthResponse {
  success: string;
  data: {
    authenticate_status: string;
    role: string;
    expired_at: string;
  };
}
interface AuthRequest {
  email: string;
  password: string;
}

interface UserList {
  paginate: PaginateDTO;
  list: User[];
}

interface UserListResponseInterface {
  meta: string;
  data: {
    data: UserDTO[];
    pagination: any;
  };
}

interface ForgotRequest {
  email: string;
}

interface ResetPasswordRequest {
  password: string;
  password_confirmation: string;
}

class UserApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async login(data: AuthRequest): Promise<any> {
    const response = await this.getHttp().post<ApiResponse>("/login", data);

    return response.data;
  }

  async link(data): Promise<any> {
    const response = await this.getHttp().post<ApiResponse>("/users/link", data);

    return response.data;
  }

  async logout(): Promise<AxiosResponse> {
    return this.getHttp().get<AuthResponse>("/logout");
  }
  async me(): Promise<any> {
    const response = await this.getHttp().get<any>("/me");

    return response.data;
  }

  async index(query = {}, data = {}): Promise<User[]> {
    const response = await this.getHttp().get<any>("/users", {
      data: data,
      params: query,
    });
    if (response.status === 200) {
      return response.data.data.map((item) => new User(item));
    }
  }

  async indexWithPagination(query): Promise<UserList> {
    const response = await this.getHttp().get<UserListResponseInterface>(
      "/users/pagination",
      {
        params: query,
      }
    );

    if (response.status !== 200) {
      return;
    }

    const list = response.data.data.data.map((item) => {
      return new User(item);
    });
    const paginate = new PaginateModel({
      page: response.data.data.pagination.current_page,
      pageCount: response.data.data.pagination.last_pages,
      start: response.data.data.pagination.current_page,
      end: response.data.data.pagination.last_pages,
      count: response.data.data.pagination.total,
    });
    return {
      list,
      paginate,
    };
  }

  async deleteCooperate(id): Promise<any> {
    const response = await this.getHttp().delete<any>(
      "/users/cooperate/" + id,
    );

    return response.data;
  }

  async deleteUser(id): Promise<any> {
    return await this.getHttp().delete<any>(
      "/users/" + id,
    );
  }

  async create(user: User): Promise<any> {

    const userData = this.tranformCreateUserRequest(user);
    const response = await this.getHttp().post<any>("/users/" , userData);

    return response.data;
  }

  async createCooperate(userCompany: UserCompany): Promise<any> {
    const dataTranform = Object.assign({}, userCompany);
    dataTranform.affiliation_company_id = dataTranform.role_id == 1 ? dataTranform.company_id : dataTranform.affiliation_company_id;
    const response = await this.getHttp().post<any>("/users/cooperate" , dataTranform);

    return response.data;
  }

  async getUserCooperation(id): Promise<any> {
    const response = await this.getHttp().get<any>("/users-companies/" + id);

    if (response.status === 200) {
      return response.data;
    }
  }

  public tranformCreateUserRequest(user) {
    const dataTranform = Object.assign({}, user);
    dataTranform.type = 2;

    return dataTranform;
  }

  async updateMe(user: User) {
    const response = await this.getHttp().put<any>("/me", user);
    return response.data
  }

  async forgotPassword(data: ForgotRequest):Promise<any> {
    const response = await this.getHttp().post<ApiResponse>('/forgot-password', data);

    return response.data;
  }

  async resetPassword(token, data: ResetPasswordRequest):Promise<any> {
    const response = await this.getHttp().post<ApiResponse>('/reset-password/' + token, data);

    return response.data;
  }

  async verifyToken(token: string):Promise<any> {
    const response = await this.getHttp().get<ApiResponse>('/reset-password/' + token)

    return response.data;
  }
}
export default new UserApi();
